import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { PortalShell } from "@/layouts/PortalShell";
import { usePrimaryComplaintStore } from "@/store/primaryComplaint";
import { WizardLayout } from "./WizardLayout";

/** Wraps /complaint/* routes with PortalShell (header; no legal footer — Back/Next bar is in the wizard flow). */
export function ComplaintLayout() {
  // Warn before closing/reloading the tab while an answer is still being saved, so a patient never
  // walks away thinking their entry was recorded when a slow/dropped request hasn't finished.
  const pendingSaves = usePrimaryComplaintStore((s) => s.pendingSaves);
  useEffect(() => {
    if (pendingSaves <= 0) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [pendingSaves]);

  return (
    <PortalShell className="bg-muted/30">
      <div className="content-body account-layout flex h-full min-h-0 w-full min-w-0 max-w-full flex-1 flex-col overflow-x-hidden">
        <WizardLayout>
          <Outlet />
        </WizardLayout>
      </div>
    </PortalShell>
  );
}
